module.exports = __webpack_public_path__ + "media/images/map/location64x64-e0411aae7ca856a06b89cf61a774420d.png";